import { Card, Button, Empty } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { FileQuestion } from 'lucide-react';

const RetryAttachment = ({ onRetry }) => (
    <Card className='file-not-found'>
        <Empty
            image={<FileQuestion size={40} />}
            styles={{
                image: {
                    height: 40,
                }
            }}
            description='File not found'
        />
        <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onRetry}
            size="small"
            className='mt-2'
        >
            Retry
        </Button>
    </Card>
);

export default RetryAttachment;